import { render } from "./help.vue?vue&type=template&id=5cde610a"
const script = {}
script.render = render

export default script